'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("mktCourbesTauxPage", {
  bindings: {},
  template: require("./mktCourbesTauxPage.html"),
  controller: function controller($scope, $http, $translate, $numberFormat, chartUtils, mktCourbesTauxChartConfigFactory, mktCourbesTauxService, contextService, $fileDownload, $session) {
    $scope.courbes = [{
      id: "EUR",
      label: "EUR",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "USD",
      label: "USD",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "CHF",
      label: "CHF",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "GBP",
      label: "GBP",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "JPY",
      label: "JPY",
      groupe: $translate('marche.history.courbeTaux.groupe.Devise')
    }, {
      id: "TEC",
      label: "France (TEC)",
      groupe: $translate('marche.history.courbeTaux.groupe.Pays')
    }, {
      id: "OLO",
      label: "Belgique (OLO)",
      groupe: $translate('marche.history.courbeTaux.groupe.Pays')
    }];
    var dateVisualisation = contextService.getContext().dateVisualisation;
    var defautCourbe = _.find($scope.courbes, function (c) {
      return c.id === $session.getCompte().devise;
    });
    if (defautCourbe == null) {
      defautCourbe = $scope.courbes[0];
    }
    var params = $scope.params = {
      courbeId: defautCourbe.id,
      datesCustom: false,
      date1: dateVisualisation,
      date2: moment(dateVisualisation).subtract(1, 'month').toDate(),
      date3: moment(dateVisualisation).subtract(6, 'month').toDate(),
      date2Active: true,
      date3Active: true,
      avecCourbeOAT: false
    };
    $scope.$watch("params", function () {
      if (params.courbeId !== 'EUR') {
        params.avecCourbeOAT = false;
      }
      fetchDataForCourbe();
    }, true);
    var getParams = function getParams(params, isXls) {
      var requestParams = {
        courbeId: params.courbeId,
        date1: params.datesCustom ? params.date1 : null,
        date2: params.datesCustom && params.date2Active ? params.date2 : null,
        date3: params.datesCustom && params.date3Active ? params.date3 : null,
        avecCourbeOAT: params.avecCourbeOAT
      };
      if (isXls) {
        requestParams['xls'] = true;
      }
      return requestParams;
    };
    var fetchDataForCourbe = function fetchDataForCourbe() {
      $scope.loader = true;
      // todo - loader de la table, ça sera plus classe (overlay) !
      $http.get('/rest/marche/courbe-taux/indexes', {
        params: getParams(params)
      }).then(function (response) {
        $scope.indexCourbeTaux = response.data;
      }).finally(function () {
        $scope.loader = false;
      });
      setupIndexCourbeTauxTableConfig();
      mktCourbesTauxService.getCourbeTauxChartSeries(params.courbeId, params.datesCustom ? params.date1 : null, params.datesCustom && params.date2Active ? params.date2 : null, params.datesCustom && params.date3Active ? params.date3 : null, params.avecCourbeOAT).then(function (chartSeries) {
        $scope.chartConfigCourbeTaux.series = chartSeries;
      });
    };
    var setupIndexCourbeTauxTableConfig = function setupIndexCourbeTauxTableConfig() {
      var columnsFixing = [{
        attribute: 'fixingCourant',
        title: params.datesCustom ? moment(params.date1).format("DD/MM/YYYY") : $translate('marche.DernierFixing'),
        filter: "taux:2",
        cellClass: 'align-r'
      }];
      if (params.avecCourbeOAT === true) {
        columnsFixing.push({
          attribute: 'oatCourant',
          title: $translate('marche.OATEquivalente'),
          filter: "taux:2",
          cellClass: 'align-r'
        });
      }
      if (params.datesCustom === false || params.date2Active === true) {
        columnsFixing.push({
          attribute: 'fixing1Mois',
          title: params.datesCustom && params.date2Active ? moment(params.date2).format("DD/MM/YYYY") : $translate('marche.1Mois'),
          filter: "taux:2",
          cellClass: 'align-r'
        });
      }
      if (params.datesCustom === false || params.date3Active === true) {
        columnsFixing.push({
          attribute: 'fixing6Mois',
          title: params.datesCustom && params.date3Active ? moment(params.date3).format("DD/MM/YYYY") : $translate('marche.6Mois'),
          filter: "taux:2",
          cellClass: 'align-r'
        });
      }
      $scope.indexCourbeTauxTableConfig = {
        source: "indexCourbeTaux",
        height: 450,
        columns: [{
          attribute: 'index',
          title: $translate('marche.Index'),
          width: "180px",
          template: "<span> {{'index.' + model.index | translate}}</span>"
        }, {
          title: "Fixing",
          group: true,
          columns: columnsFixing
        }]
      };
    };
    $scope.chartConfigCourbeTaux = {
      options: mktCourbesTauxChartConfigFactory()
    };
    $scope.exportXls = function () {
      console.log('start download...');
      $fileDownload.start('/rest/marche/courbe-taux/indexes', getParams(params, true));
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/courbes-taux/mktCourbesTauxPage.js
// module id = 2835
// module chunks = 13